exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loading-wrapper{position:absolute;margin:0;padding:0;height:100%;width:100%;background:hsla(0,0%,100%,.8);z-index:100;top:0;left:0}.loading-wrapper.loading-wrapper-visible{display:block;animation:fade-in .5s}.loading-wrapper.loading-wrapper-fixed{position:fixed}.loading-wrapper.loading-medium .loading-img-wrapper{margin:5% auto}.loading-wrapper.loading-small .loading-img-wrapper{margin:0 auto}.loading-wrapper.loading-small .loading-img-wrapper .loading-img{width:60px;height:60px}.loading-img-wrapper{margin:20% 0;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/sass-loader/dist/cjs.js!./components/lib/Loadable/loadable.scss
// module id = 689
// module chunks = 0 1 2